import * as _ from 'lodash';
import { useState, useEffect } from 'react';
import { Checkbox, Panel, Well } from 'react-bootstrap';
import { CheckboxColumnsWrapper } from './styles';
import { CenterToggle, ISelectedCenter } from './models';

interface IProps {
    centerList: ISelectedCenter[],
    mode: string,
    onChange: (centerId: number) => void,
    onToggleChange: (toggles: number[]) => void
}

const Centers = (props: IProps) => {
    const [toggles, setToggles] = useState<number[]>([]);
    const [showUnchecked, setShowUnchecked] = useState<boolean>(false);

    useEffect(() => {
        if (props.centerList.filter(x => x.selected).length == 0) {
            setShowUnchecked(true);
        }
    }, [props.centerList, props.mode]);

    const toggleList = [
        { id: CenterToggle.All, label: 'All' },
        { id: CenterToggle.MemberCenters, label: 'Member Centers' },
        { id: CenterToggle.ProspectCenters, label: 'Prospect Centers' },
        { id: CenterToggle.DashCenters, label: 'DASH Centers' },
        { id: CenterToggle.DcnCenters, label: 'DCN Centers' },
        { id: CenterToggle.PartnerCenters, label: 'Partner Centers' },
        { id: CenterToggle.AllInNonPartnerCenters, label: 'All-In Non-Partner Centers' },
        { id: CenterToggle.MicrositeCenters, label: 'Microsite Centers' }
    ];

    const handleToggleChange = (toggle: number) => {
        let t = [...toggles];

        if (t.indexOf(toggle) >= 0) {
            t = toggles.filter(tid => tid != toggle);
        } else {
            t.push(toggle);
        }

        setToggles(t);

        props.onToggleChange(t);
    };

    const handleChange = (centerId: number) => {
        props.onChange(centerId);
    };

    const centerList = _.sortBy(props.centerList, item => item.alias.toLowerCase());
    const filteredList = showUnchecked ? centerList : centerList.filter(x => x.selected);

    const disableShowUnchecked = centerList.filter(x => x.selected).length == 0;

    return (
        <Panel>
            <Panel.Heading>Centers</Panel.Heading>
            <Panel.Body>
                <Well style={{ paddingTop: 9.5, paddingBottom: 9.5 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            {toggleList.map(toggle =>
                                <Checkbox key={'ctr-toggle-' + toggle.id} inline checked={toggles.indexOf(toggle.id) >= 0} onClick={() => handleToggleChange(toggle.id)}>{toggle.label}</Checkbox>
                            )}
                        </div>

                        <Checkbox inline style={{ marginTop: 0, marginBottom: 0 }} checked={showUnchecked} disabled={disableShowUnchecked} onClick={() => setShowUnchecked(!showUnchecked)}>Show Unchecked</Checkbox>
                    </div>
                </Well>

                <CheckboxColumnsWrapper className='row' style={{ paddingLeft: 0, paddingRight: 0 }}>
                    {filteredList.map(center =>
                        <div key={'center-' + center.id} className='col-xs-12 col-lg-1'>
                            <Checkbox value={center.id} checked={center.selected} onClick={() => handleChange(center.id)}>{center.alias}</Checkbox>
                        </div>
                    )}
                </CheckboxColumnsWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default Centers;